import {
  MultimediaCartListResponse,
  MultimediaCartItemListResponse,
  MultimediaCartItemResponse,
  MessageOkResponse,
  RedirectUrlResponse,
} from "@API/src/component/memoruHome/cart/types";
import { MemoruUnitPriceResponse } from "@API/src/component/operation/memoru/types"

export const isTypeMultimediaCartListResponse = (
  arg
): arg is MultimediaCartListResponse =>
  arg !== null &&
  typeof arg === "object" &&
  Array.isArray(arg) &&
  (arg.length === 0 || isTypeMultimediaCartItemResponse(arg[0]));

export const isTypeMultimediaCartItemListResponse = (
  arg
): arg is MultimediaCartItemListResponse =>
  arg !== null &&
  Array.isArray(arg) &&
  (arg.length === 0 || isTypeMultimediaCartItemResponse(arg[0]));

export const isTypeMultimediaCartItemResponse = (
  arg
): arg is MultimediaCartItemResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MultimediaCartItemResponse).multimediaId === "number";

export const isTypeMessageOkResponse = (arg): arg is MessageOkResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MessageOkResponse).message === "string";

  export const isTypeRedirectUrlResponse = (arg): arg is RedirectUrlResponse =>
    arg !== null &&
    typeof arg === "object" &&
    typeof (arg as RedirectUrlResponse).message === "string" &&
    typeof (arg as RedirectUrlResponse).execMemoruRes.accessPass === "string" &&
    typeof (arg as RedirectUrlResponse).execMemoruRes.redirectUrl === "string"

export const isTypeMemoruUnitPriceResponse = (
  arg
): arg is MemoruUnitPriceResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MemoruUnitPriceResponse).photoPrice === "number";
